import React from 'react'
import { Col } from 'antd'
import styled from 'styled-components'
import { TableRow } from 'Components/Shared/Table'
import { EditIcon, TrashIcon } from 'Components/Shared/Icon'
import { Zone } from 'features/admin/zone/types'
import { Link } from 'react-router-dom'
import { textToLowerCase } from 'utils/format'

type DefaultProps = {
  item: Zone
  onDelete: (item: Zone) => void
}

type Props = DefaultProps

const RowItem: React.FC<Props> = ({ item, onDelete }) => {
  const isUsed = textToLowerCase(item.Status) === 'used'

  return (
    <RowModel>
      <TableRow minHeight={60} spaceBetweenRow={8} paddingLeft={24}>
        <Col span={7}>
          <Link to={`/check-zone/${item.CheckListID}/edit`}>
            <Name>{item.CheckListName}</Name>
          </Link>
        </Col>
        <Col span={3}>{item.ProjectTypeName}</Col>
        <Col span={3}>{item.ProjectUsedCounter}</Col>
        <Col span={3}>{item.CreatedDate}</Col>

        <Col span={6}>
          {item.UpdatedDate} - โดย {item.UpdatedBy}
        </Col>
        <Col span={2}>
          <Icon>
            <Link to={`/check-zone/${item.CheckListID}/edit`}>
              <EditIcon size={20} color="#8b99a7" />
            </Link>
          </Icon>
          {!isUsed && (
            <Icon onClick={() => onDelete(item)}>
              <TrashIcon size={20} color="#8b99a7" />
            </Icon>
          )}
        </Col>
      </TableRow>
    </RowModel>
  )
}

const RowModel = styled.div`
  cursor: pointer;
`

const Name = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  color: #000;
  display: flex;
  align-items: center;
  .img {
    height: 40px;
    width: 40px;
    margin-right: 22px;
  }
`
const Icon = styled.div`
  float: left;
  margin-right: 20px;
  margin-top: 5px;
  cursor: pointer;
`

export default RowItem
